module.exports = __webpack_public_path__ + "static/site/img/development_1.d593e8d9.gif";